import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LocationsTurnsService } from 'src/app/services/turns-services/locations-turns-service/locations-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-turns-locations-breadcrumb-card',
  templateUrl: './turns-locations-breadcrumb-card.component.html',
  styleUrls: ['./turns-locations-breadcrumb-card.component.scss']
})
export class TurnsLocationsBreadcrumbCardComponent implements OnInit {

  @Input() locations;
  filterOpened: boolean;
  viewDisposition;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private userStorageService: UserStorageService,
              private locationsTurnsService: LocationsTurnsService) {
                this.viewDisposition = 'grid';
              }

  ngOnInit() {
    if (this.userStorageService.getFilterNotifications()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.locationsTurnsService.toggleLocationsDisposition(viewDis);
  }

  public createLocation() {
    this.router.navigate(['../location'], { relativeTo: this.activatedRoute.parent });
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public search(event) {
    this.locationsTurnsService.searchLocations(event.target.value);
  }

}
